import axios from 'axios';

const api = axios.create({
  baseURL: '/api' ,
});

// Interceptor: agregar token JWT a cada request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Interceptor: si expira el token, redirigir al login
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authService = {
  login: (email, password) =>
    api.post('/auth/login', { email, password }),
  me: () => api.get('/auth/me'),
};

export const separadoresService = {
  getAll: () => api.get('/separadores/'),
  getOne: (id) => api.get(`/separadores/${id}`),
  getHistorial: (id) => api.get(`/separadores/${id}/historial`),
};

export default api;
